<div class="segmented-control__wrapper" [class.disabled]="disabled" [class.is-error]="error">
  @if (label) {
    <div class="segmented-control__label">
      {{ label }}
    </div>
  }
  <div class="segmented-control__items">
    @for (item of items; track item.value) {
      <button
        type="button"
        class="segmented-control__item"
        [disabled]="item.disabled || disabled"
        [class.is-disabled]="item.disabled"
        [class.is-active]="item.value === this.value"
        [class.is-moreThanTwoItem]="items.length > 2"
        id="rc-segmented-control-{{ item.value }}"
        (click)="didSelect($event, item)"
      >
        @if (item.icon) {
          <app-icon [class]="'segmented-control__item__icon' + ' segmented-control__item__icon-' + item.icon" [name]="item.icon"></app-icon>
        }
        @if (item.label) {
          <span class="segmented-control__item__label">{{ item.label }}</span>
        }
      </button>
    }
  </div>
  @if (error) {
    <span class="segmented-control__error">{{ error }}</span>
  }
</div>
